import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  Configure: {
    id: 'course-authoring.header.configure.text',
    defaultMessage: 'Configure',
  },
  viewBtnText: {
    id: 'course-authoring.header.viewbtn.text',
    defaultMessage: 'View as a Viewer',
  },
  saveBtnText: {
    id: 'course-authoring.header.saveBtn.text',
    defaultMessage: 'Publish Course',
  }
});

export default messages;
